import type { ComponentProps } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

interface Props extends ComponentProps<'button'> {
  variant?: Variant;
  size?: 'sm' | 'md';
  glow?: boolean;
}

export default function Button({
  variant = 'primary',
  size = 'md',
  glow = false,
  className = '',
  children,
  ...rest
}: Props) {
  const sizeStyles = size === 'sm' ? 'px-3 py-1.5 text-[13px]' : 'px-5 py-3 text-[14px]';

  let variantStyles = '';
  if (variant === 'primary') {
    variantStyles =
      'bg-accent text-accent-fg border border-accent ' +
      'hover:bg-accent-hover active:bg-accent-pressed ' +
      'hover:-translate-y-px ' +
      (glow ? 'hover:shadow-flare ' : '');
  } else if (variant === 'secondary') {
    variantStyles =
      'bg-transparent text-fg border border-line ' +
      'hover:border-fg/60 hover:bg-elevated';
  } else {
    variantStyles =
      'bg-transparent text-muted border border-transparent ' +
      'hover:text-fg';
  }

  return (
    <button
      className={
        `inline-flex items-center justify-center gap-2 rounded-full font-semibold ` +
        `transition-all duration-300 ease-[cubic-bezier(0.22,1,0.36,1)] ` +
        `disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:translate-y-0 ` +
        `focus:outline-none focus-visible:shadow-focus ` +
        `${sizeStyles} ${variantStyles} ${className}`
      }
      {...rest}
    >
      {children}
    </button>
  );
}
